import { useGenerator } from "@/app/context/GeneratorContext";
import GemCost from "../generatorViewPort/gemCost";
import { useMemo } from "react";

export default function TagCounter({
  tagCost,
  translations,
}: {
  tagCost: number;
  translations: any;
}) {
  const { tagList, batchSize } = useGenerator();
  const totalSelected = tagList.reduce((total, category) => {
    const selectedInCategory = category.tags.filter((tag) => tag.selected).length;
    return total + selectedInCategory;
  }, 0);

  const totalAmount = useMemo(() => {
    return totalSelected > 6 ? (totalSelected - 6) * tagCost : 0;
  }, [totalSelected, tagCost]);

  return (
    <div className="mb-4 shadow-sm">
      <div
        className="flex flex-row py-1 pl-5 pr-5 text-sm text-white sm:rounded-lg sm:pl-0 sm:pr-2 md:pl-0 md:pr-4" //bg-[#2B2D31] border-[0.5px] border-[#3C3C3C] py-4
      >
        <div className="font-semibold">{translations.tagLimit}</div>
        <div className="my-auto ml-auto flex h-auto flex-row">
          <GemCost amount={totalAmount} multiplier={batchSize} />
        </div>
      </div>
    </div>
  );
}
